import { render, staticRenderFns } from "./CompositionApiCodeOrganizationOld.vue?vue&type=template&id=009d0f30&scoped=true&functional=true&"
var script = {}
import style0 from "./CompositionApiCodeOrganizationOld.vue?vue&type=style&index=0&id=009d0f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "009d0f30",
  null
  
)

export default component.exports